export interface StockReceiptsSalesOrderPurchaseAllocation {
  id: string;
  purchaseOrderLineId: string;
  allocatedPurchaseOrderLineId: string;
  allocationType: string;
  orderAndLineNo: string;
  key: string;
  name: string;
  balance: number;
  allocated: number;
  qtyRequired: number;
  deliveryDate: Date;
  selected: boolean;
}
